import type { Container } from 'pixi.js';
import type { App } from '../app/App';
import { BoosterIntroductionPopup } from '../game/boosters/BoosterIntroductionPopup';
import type { BoosterType } from '../game/boosters/types';
import { GAME_ECONOMY_SETTINGS } from '../game/GameConstants';

export function openBoosterIntroductionPopup(
  app: App,
  boosterType: BoosterType,
  collect: boolean,
  target?: Container,
): Promise<void> {
  const popup = new BoosterIntroductionPopup({
    booster: GAME_ECONOMY_SETTINGS.boosters[boosterType],
    collectVersion: collect,
    buttonTarget: target,
    boosterAmount: app.stateController.getBoosterInventoryAmount(boosterType),
  });

  void app.controller.popups.addPopup({
    popupInstance: popup,
    settings: { hideRays: true, overlay: false },
  });

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  popup.onButtonClicked.connect(async () => {
    await Promise.all([
      collect ? popup.animateIconToTarget() : Promise.resolve(),
      app.controller.popups.closeActivePopup(),
    ]);
    resolve();
  });

  return promise;
}
